import { styled } from '../../lib/stitches'

const Container = styled('div', {
  paddingTop: '13px',
  paddingBottom: '13px',
  borderBottom: '1px solid var(--gray-3)',
  display: 'flex',
  userSelect: 'none'
})

const Text = styled('span', {
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 600
})

const Column = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  marginRight: '8px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  variants: {
    width: {
      1: { flex: '1' },
      2: { flex: '2' }
    }
  }
})

const Header = () => {
  // some business logic with sort event handlers
  return (
    <Container css={{ paddingRight: '16px' }}>
      <Column width={2}>
        <Text>{'Name'}</Text>
      </Column>
      <Column width={1}>
        <Text>{'Artist'}</Text>
      </Column>
      <Column width={1}>
        <Text>{'# Remixes'}</Text>
      </Column>
      <Column width={1} />
    </Container>
  )
}

const TableWrapper = styled('div', {
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
})

export { TableWrapper, Header, Column, Container, Text }
